module.exports = __webpack_public_path__ + "img/T5-A-xh_15.f3fbbeb3.png";